// React Imports
import { useEffect } from "react";

import "./AlgoManagement.styles.scss";

// Components Imports
import { AlgoTable, Skeleton } from "./components";

// Hooks Imports
import { useFetchInteractionsQuery } from "./services/algoManagementApi";

// Material UI Imports
import { SvgIcon, useTheme } from "@mui/material";

// SVG Imports
import LogoSVG from "@/svgs/pulse_prime_logo.svg?react";
import { useAlerts } from "@/hooks";
import { getErrorMessage } from "../../utils/getErrorMessage";

const AlgoManagement = () => {
    const theme = useTheme();
    const { showError } = useAlerts();
    const {
        data: interactionsData,
        isLoading: isLoadingInteractionsData,
        isError: isErrorInteractionsData,
        error: errorInteractionsData,
    } = useFetchInteractionsQuery();

    useEffect(() => {
        if (isErrorInteractionsData) {
            showError(`Failed to fetch Interactions: ${getErrorMessage(errorInteractionsData)}`);
        }
    }, [isErrorInteractionsData, errorInteractionsData, showError]);

    return (
        <div className="pulse-sidenav-adjusted-container" style={{ backgroundColor: theme.palette.bg["900"] }}>
            <SvgIcon
                sx={{
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                }}
                children={<LogoSVG style={{ color: theme.palette.bg[800] }} />}
            />

            <div
                className="pulse-row pulse-mb-1"
                style={{ display: "flex", alignItems: "center", gap: 12 }}
            >
                <p className="pulse-typography-headline-6 pulse-color--background-50" style={{ margin: 0 }}>
                    Algo Management
                </p>
            </div>

            {isLoadingInteractionsData ? (
                <Skeleton />
            ) : (
                <AlgoTable interactionsData={interactionsData ?? undefined} />
            )}
        </div>
    );
};

export default AlgoManagement;
